import { CameraFilled, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { ReactNode, useMemo } from "react";
import { TaskStatus } from "tm-shared/types";

import PlateOutlined from "@/assets/icons/plate.svg?react";

export type TaskStatusVariant = "neutral" | "success" | "error";

interface UseTaskStatusMetaOptions {
    photo?: boolean;
}

export const useTaskStatusMeta = (
    status: TaskStatus,
    options: UseTaskStatusMetaOptions = {},
) => {
    const { photo = false } = options;

    const variant: TaskStatusVariant = useMemo(() => {
        switch (status) {
            case TaskStatus.Completed:
                return "success";
            case TaskStatus.Rejected:
                return "error";
            case TaskStatus.Incomplete:
            default:
                return "neutral";
        }
    }, [status]);

    const icon: ReactNode = useMemo(() => {
        if (status === TaskStatus.Incomplete) {
            return <PlateOutlined />;
        }

        if (photo) {
            return <CameraFilled />;
        }

        if (status === TaskStatus.Completed) {
            return <CheckOutlined />;
        }

        return <CloseOutlined />;
    }, [status, photo]);

    return { variant, icon };
};
